import { Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { t } from '@/lib/i18n';

/** S-03 — 404 */
export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center px-6 text-center">
      <div className="grid h-20 w-20 place-items-center rounded-full bg-subtle text-ink-3">
        <Search size={32} strokeWidth={1.75} />
      </div>
      <h1 className="mt-6 text-[17px] font-semibold text-ink">{t('Sahifa topilmadi')}</h1>
      <Button className="mt-8" onClick={() => navigate('/')}>
        {t('Bosh sahifaga')}
      </Button>
    </div>
  );
}
